import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { strAuth01, strAuth02 } from "../../../js/authText.js";
import { useHistory } from "react-router-dom";
import SubBanner from "../../comm/SubBanner";

function JoinStep01(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [auth01, setAuth01] = useState(false);
  const [auth02, setAuth02] = useState(false);

  useEffect(
    () => {
      dispatch({
        type: "pageChange",
        payload: { sub01: "회원가입", sub02: "약관동의" },
      });
      dispatch({ type: "loadingChange", payload: true });

      setTimeout(() => {
        dispatch({ type: "loadingChange", payload: false });
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <SubBanner id="member" />

      <section className="appoinment section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-2"></div>

            <div className="col-lg-6 col-md-8">
              <div className="row">
                <div className="joinstep-container">
                  <div className="joinstep active">
                    <span>01</span>
                    <span>이용약관동의</span>
                  </div>
                  <div className="joinstep">
                    <span>02</span>
                    <span>조합원인증</span>
                  </div>
                  <div className="joinstep">
                    <span>03</span>
                    <span>회원가입</span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <p>
                    이용약관과 개인정보취급방침에 대해 잘 확인하신 후 동의
                    부탁드립니다.
                    <br />
                    동의를 원치 않는 분께서는 회원가입을 진행하실 수 없습니다.
                  </p>
                </div>
              </div>

              <div className="row mt-3 ">
                <div className="col-lg-12">
                  <Form.Check
                    inline
                    label="이용약관에 동의합니다."
                    type="checkbox"
                    id="checkAuth01"
                    onChange={(e) => setAuth01(e.target.checked)}
                  />{" "}
                  {auth01}
                </div>

                <div className="col-lg-12">
                  <Form.Control
                    as="textarea"
                    style={{
                      height: "250px",
                      color: "#666666",
                      border: "1px solid #d1d1d1",
                    }}
                    value={strAuth01}
                    className="auth-text"
                    readOnly={true}
                  />
                </div>
              </div>

              <div className="row mt-3 ">
                <div className="col-lg-12">
                  <Form.Check
                    inline
                    label="개인정보 취급방침에 동의합니다."
                    type="checkbox"
                    id="checkAuth02"
                    onChange={(e) => setAuth02(e.target.checked)}
                  />{" "}
                  {auth02}
                </div>

                <div className="col-lg-12">
                  <Form.Control
                    as="textarea"
                    style={{
                      height: "250px",
                      color: "#666666",
                      border: "1px solid #d1d1d1",
                    }}
                    value={strAuth02}
                    className="auth-text"
                    readOnly={true}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-12 col-md-12 text-right">
                  <span
                    className="btn btn-main btn-icon btn-round-full"
                    onClick={() =>
                      auth01 && auth02
                        ? history.push("/JoinStep02")
                        : alert(
                            "이용약관 및 개인정보 취급방침에 미동의시 진행이 불가능합니다."
                          )
                    }
                  >
                    다음
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-2"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default JoinStep01;
